import { Alternativa, Resolucao } from "../../../sdk/@types";
import { ChoiceButton } from "../ChoiceButton/ChoiceButton";
import MarkdownEditor from "../MarkdownEditor";

interface Props{
    questionReceived? : Resolucao.ResolucaoQuestao
    onChose? : (item : Resolucao.ResolucaoQuestao, choice : Alternativa.Alternativa) => void;
    showResolution?: boolean;
}

export const Quizz = ({questionReceived = {}, onChose, showResolution}:Props) => {
    const {question} = questionReceived;

    const handleSituation = (item: Alternativa.Alternativa): "correct" | "wrong" | "selected" | "default" => {
        const { answer } = questionReceived;

        // Com a resolução liberada, o gabarito vale mesmo sem resposta: uma
        // questão que o aluno deixou em branco também tem uma alternativa
        // certa para mostrar. Antes o `!answer` saía antes desta checagem, e
        // quem não respondeu via a questão sem nenhuma marcação.
        if (showResolution) {
            if (item.correct) return "correct";
            if (answer?.description === item.description) return "wrong";
            return "default";
        }

        if (!answer) return "default";

        return answer.description === item.description ? "selected" : "default";
    };

    /**
     * A justificativa que cada alternativa mostra na resolução.
     *
     * Antes só a correta exibia a sua. A do item que o aluno marcou é a que
     * mais importa para ele — é ela que explica o próprio erro —, e ficava
     * escondida no dado sem nunca chegar à tela.
     *
     * As demais continuam sem texto de propósito: despejar a justificativa de
     * toda alternativa transformaria a revisão num muro de texto. Mostra-se a
     * do gabarito e a da escolhida.
     */
    const justificativa = (item: Alternativa.Alternativa): string => {
        if (!showResolution) return '';
        const situacao = handleSituation(item);
        if (situacao === 'correct' || situacao === 'wrong') {
            return item.rationale ?? '';
        }
        return '';
    };


    return (
        <>
            <form
                className="max-w-[80%] mx-auto p-4 bg-white dark:bg-gray-900 shadow-md rounded-2xl flex flex-col gap-4 w-full sm:w-[90%]"
            >
                <div className="border-b pb-2 pl-2 mb-2">
                    <p className="font-bold text-xl">{question?.subject?.name}</p>
                </div>
                <div>
                    <MarkdownEditor
                        readOnly={true}
                        value={question?.statement}
                    />          
                </div>
                <div className="flex flex-col w-full gap-2">
                    {
                        question?.choices?.filter((item) => item.description?.trim()).map((item, index)  => (
                            <ChoiceButton situation={handleSituation(item)} internalText={justificativa(item)} key={index} letter={String.fromCharCode(65 + index)} label={item.description ?? ""}  onClick={() => onChose?.(questionReceived,item)!} />
                        ))
                    }    
                </div>
            </form>
        </>
    );
}

export default Quizz;